import { useCallback, useEffect, useRef, useState } from 'react';
import { getContainerHeight, getContainerWidth } from './ConnectedPagesHelperFunctions';

export function useConnectedPagesGraphResizeHandler(initialRadiusOfFirstRow: number) {
  const [containerDimensions, setContainerDimensions] = useState({ width: 0, height: 0 });
  const [radiusOfNodeSphere, setRadiusOfNodeSphere] = useState(initialRadiusOfFirstRow || 0);
  const connectedPagesGraphContainer = useRef<HTMLUListElement>(null);
  const resizeObserver = useRef<ResizeObserver | undefined>(undefined);

  const onWindowResize = useCallback(() => {
    if (connectedPagesGraphContainer.current) {
      const newContainerDimensions = {
        width: getContainerWidth(connectedPagesGraphContainer.current),
        height: getContainerHeight(connectedPagesGraphContainer.current),
      };

      setContainerDimensions(newContainerDimensions);
      setRadiusOfNodeSphere(newContainerDimensions.width / 3);
    }
  }, []);

  useEffect(() => {
    if (connectedPagesGraphContainer.current) {
      const newContainerDimensions = {
        width: getContainerWidth(connectedPagesGraphContainer.current),
        height: getContainerHeight(connectedPagesGraphContainer.current),
      };

      setContainerDimensions(newContainerDimensions);
      setRadiusOfNodeSphere(newContainerDimensions.width / 3);
    }
  }, []);

  useEffect(() => {
    resizeObserver.current = new ResizeObserver(onWindowResize);

    if (connectedPagesGraphContainer.current) {
      resizeObserver.current.observe(connectedPagesGraphContainer.current);
    }

    const currentContainer = connectedPagesGraphContainer.current;

    return () => {
      if (resizeObserver?.current && currentContainer) {
        resizeObserver.current.unobserve(currentContainer);
      }
    };
  }, [onWindowResize]);

  return {
    connectedPagesGraphContainer,
    containerDimensions,
    radiusOfNodeSphere,
    setRadiusOfNodeSphere,
  };
}
